import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ChartColorService} from '../../../chart-plugins/chart-color-service';
import {ChartDataTransformService} from '../../../chart-plugins/chart-data-transform.service';
import {GraphData, GraphRequestOptions} from '../../../types/nso-data-portal/census-data';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class ChartRestService {

  constructor(private http: HttpClient,
              private chartColorService: ChartColorService,
              private transformService: ChartDataTransformService) {
  }


  getCensusGraphs(options: GraphRequestOptions): Observable<GraphData> {
    const params = new HttpParams()
      .set('graphType', options.type)
      .set('dateSelectionBarGraph', options.barDate)
      .set('dateSelectionLineGraph', options.lineDate);

    return this.http.get<GraphData>(options.route, {params}).pipe(
      map((data: GraphData) => {
        this.transformService.transformBarData(data.barGraphData);
        this.transformService.transformLineData(data.lineGraphData);
        this.transformService.transformDonutData(data.donutBarData);
        this.chartColorService.initialize(data);
        return data;
      })
    );
  }

  getDetailedCensusGraphs(options: GraphRequestOptions): Observable<GraphData> {
    const params = new HttpParams()
      .set('graphType', options.type)
      .set('dateSelectionBarGraph', options.barDate)
      .set('dateSelectionLineGraph', options.lineDate);

    return this.http.get<GraphData>(options.route + '/detail', {params}).pipe(
      map((data: GraphData) => {
        this.transformService.transformBarData(data.barGraphData);
        this.transformService.transformLineData(data.lineGraphData);
        this.transformService.transformDonutData(data.donutBarData);
        this.transformService.transformDonutData(data.beneficiariesGraph);
        this.chartColorService.initialize(data);
        return data;
      })
    );
  }
}
